import { useQuery } from "@tanstack/react-query";

import { productsQuery } from "#modules/products/infra/products.query";

import { ProductDto } from "../infra/fetchProducts.api";

type Props = {
  initialData?: ProductDto[];
};

export const useProducts = (params?: Props) => {
  const { data, ...rest } = useQuery({
    ...productsQuery(),
    ...(params?.initialData !== undefined && { initialData: params.initialData }),
  });

  return { products: data ?? [], ...rest };
};
